import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchPaymentMethodList = createAsyncThunk(
  "fetchPaymentMethodList",
  async ({ channel_id }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.get(
        `${REWARD_BASE_URL}channel/${channel_id}/payment-methods`
      );
      return response.data.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const PaymentMethodListSlice = createSlice({
  name: "PaymentMethodListSlice",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPaymentMethodList.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(fetchPaymentMethodList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });
    builder.addCase(fetchPaymentMethodList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default PaymentMethodListSlice.reducer;